import type { EntityState } from '@core/ngrx-legacy';
import { createEntityCollectionStore, DEFAULT_SCOPE_NAME, pipeState } from '@core/ngrx-legacy';
import type { JobSkillsSummaryDetails } from '@core/positions-and-skills-types';

type State = EntityState<JobSkillsSummaryDetails>;

const idSelector = ({ positionGuid }: JobSkillsSummaryDetails) => positionGuid;

const { actions, selectors, reducer, namespace } =
  createEntityCollectionStore<JobSkillsSummaryDetails>()('ViewboxSkillsSummary', {
    idSelector,

    customActions: adapter => ({
      fetchCollection: (state: State, payload: { candidateId: number }) =>
        pipeState(state, next =>
          adapter.markAsPending(next, {
            scope: sharedSkillsSummaryCandidateScope(payload.candidateId),
            entities: [],
          }),
        ),
      fetchCollectionSuccess: (
        state: State,
        payload: {
          data: JobSkillsSummaryDetails[];
          scope: string;
        },
      ) =>
        pipeState(
          state,
          next => adapter.setMany(next, payload.data, { scope: payload.scope }),
          next =>
            adapter.markAsLoaded(next, {
              scope: payload.scope || DEFAULT_SCOPE_NAME,
              entities: payload.data.map(e => idSelector(e)),
            }),
        ),
    }),
  });

export const sharedSkillsSummaryCandidateScope = (candidateId: number) =>
  `candidate_${candidateId}`;

export {
  actions as ViewboxSkillsSummaryActions,
  selectors as ViewboxSkillsSummarySelectors,
  reducer as ViewboxSkillsSummaryReducer,
  namespace as ViewboxSkillsSummaryNamespace,
};
